export default __webpack_public_path__ + "static/media/Logo-Inicio-calculadoras-Reblozyl.88ecf7ba.png";